import createReducer from "../../createReducer";
import { googleSheetsDataHandlers } from "../handlers";
import { IGoogleSheetsState } from "../types";

export const googleSheets: IGoogleSheetsState = {
    isLoading: false,
    error: null,
    sheetsData: null,
};

export default createReducer(googleSheets, googleSheetsDataHandlers);
